// Dependencies
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// Material UI Components
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Fab } from '@material-ui/core';
import { AddOutlined } from '@material-ui/icons';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import InfiniteScrollList from '../../UI/InfiniteScrollList';

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SearchToolbar from '../../SearchToolbar';

// Tour
import { useTour } from '@reactour/tour';
import { tourSteps } from '../../TourSteps';
import ExportDataFilter from '../../ExportDataFilter';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 15,
      paddingRight: 15,
      marginTop: 20
    },
    [theme.breakpoints.up('xs')]: {
      marginTop: 20,
      paddingLeft: 15,
      paddingRight: 15
    },
    [theme.breakpoints.up(500)]: {
      marginTop: 40,
      paddingLeft: 15,
      paddingRight: 15
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 40,
      paddingLeft: 12,
      paddingRight: 12
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 40,
      paddingLeft: 33,
      paddingRight: 33
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: 40,
      paddingLeft: 80,
      paddingRight: 80
    }
  },
  hideOnSmallScreen: {
    display: 'none',
    [theme.breakpoints.up('xl')]: {
      display: 'flex'
    }
  },
  gridItem: {
    width: '100%',
    marginBottom: 16
  },
  title: {
    color: '#CFD5E5',
    fontSize: '1rem',
    textTransform: 'uppercase',
    padding: '2rem 0'
  },
  topBtns: {
    padding: '1rem',
    textTransform: 'uppercase'
  },
  btn: {
    marginRight: '1rem',
    flexShrink: 0
  },
  search: {
    marginTop: '1.5rem'
  }
}));

const FileListView = (props) => {
  const { role } = props;
  const { setIsOpen, setCurrentStep, setSteps } = useTour();
  const classes = useStyles();
  const { t } = useTranslation();
  const hideButtonAdd = (role === 'admin' || role === 'editor');
  const justifyAlign = hideButtonAdd ? 'space-between' : 'flex-end';

  useEffect(() => {
    const tour = JSON.parse(localStorage.getItem('tour-file'));
    setSteps(tourSteps.createNewHash);
    setCurrentStep(0);
    setIsOpen(tour);
  }, []);

  return (
    <Grid container className={classes.mainContainer} direction='column'>
      <Grid container direction='column' item xs={12} md={10}>
        <Grid container justify={justifyAlign} >
          {hideButtonAdd && <Grid item className={classes.topBtns}>
            <Fab
              component={RouterLink}
              to='/file/new'
              className={classes.btn}
              aria-label='Add'
              color='primary'
            >
              <AddOutlined className='files-newHash' />
            </Fab>
            <span>
              {t('fileListView:newFlowFromFile')}
            </span>
          </Grid>}
          <Grid item className={classes.topBtns}>
            <ExportDataFilter type='file' />
          </Grid>
        </Grid>
        <Grid item>
          <div className={classes.search}>
            <SearchToolbar visibleFor={['/file']} />
          </div>
        </Grid>
      </Grid>

      <Grid container item xs={12} md={10} style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <InfiniteScrollList />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
    visibleTabs: state.config.visibleTabs,
    documents: state.documents.documents,
    role: state.config.role,
    appConfig: state.config
  };
};

FileListView.propTypes = {
  documents: PropTypes.array.isRequired,
  role: PropTypes.string.isRequired,
  appConfig: PropTypes.object.isRequired
};

export default withRouter(
  connect(mapStateToProps)(FileListView)
);
